import axiosInstance from "global/helpers/axiosInstance";
import { useContext, useEffect, useState } from "react";
import Abm from "_+_Portal/_-_Admin/components/Abm/Abm";
import Table from "_+_Portal/_-_Admin/components/Table/Table";
import { SelectedItem, wsGetAbm } from "_+_Portal/_-_Admin/context/action/Abm/abm";
import { AdminContext } from "_+_Portal/_-_Admin/context/Provider";
import Layout from "../../../../global/component/Genericos/Layout/Layout";
import { config, configAbm } from "./config";
import { ContainerBeneficios, TableContainer } from "./localStyle";

const Beneficios = () => {
    const {
        abmState,
        abmDispatch
    } = useContext(AdminContext);

    const [data, setData] = useState(false);
    
    useEffect(()=> {
        if(!data){
             axiosInstance().then( respuesta => {
                 respuesta
                 .get(configAbm.urls[0])
                 .then(resp => {                    
                    wsGetAbm([], false,resp.data, [])(abmDispatch);
                 })
                 .catch((resp) => {
                    // setData(false); 
                    // wsGetAbm([], false,resp.data, [])(abmDispatch);
                 })
             })
        }
     },[])

     useEffect(() => {
        if(abmState.abm.data?.data?.length > 0) {
            config.data =abmState.abm.data.data; 
            setData({...config}); 
        }
     },[abmState.abm.data, abmState.abm.loading])


     const handleChange = (data) => {
        if(data[0]){
            SelectedItem(data[0])(abmDispatch);
        }else {
            SelectedItem(false)(abmDispatch);
        }
     }; 
     
    
    return (
        <Layout  positionSidebar={2}>

            <ContainerBeneficios>
                <TableContainer>
                    <Abm configAbm={configAbm}  />
                    {
                        !data  ||  abmState.abm.loading ? <span className="cargando">Cargando...</span> : <Table config={data} onChange={handleChange} />
                    }

                </TableContainer>
            </ContainerBeneficios>
        </Layout>
    )
}

export default Beneficios;

